import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section content has-text-centered" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Khiza DAO", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("connected wallet: ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("vendor contract: ")
const _hoisted_9 = { class: "is-flex is-justify-content-center mb-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("footer", { class: "footer mt-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content has-text-centered" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "TokenVendor"),
      /*#__PURE__*/_createTextVNode(" by "),
      /*#__PURE__*/_createElementVNode("a", { href: "https://khizadao.com/" }, "Khiza DAO"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Address = _resolveComponent("Address")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WaitForTransactionModal = _resolveComponent("WaitForTransactionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, "network: " + _toDisplayString(_ctx.$store.getters['network'] == 137 ? 'polygon' : _ctx.$store.getters['network'] == 80001 ? 'mumbai' : 'unknown'), 1),
        (_ctx.$store.getters['walletAddress'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Address, {
                value: _ctx.$store.getters['walletAddress']
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$web3.vendorContract)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Address, {
                value: _ctx.$web3.vendorContract.address
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.getters['walletAddress'])
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _toDisplayString(_ctx.$t('actions.logout')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        })),
        _createVNode(_component_WaitForTransactionModal)
      ])
    ]),
    _hoisted_10
  ]))
}